// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// types
import { DashboardStateProps } from 'types/dashboards';

// ----------------------------------------------------------------------

const initialState: DashboardStateProps = {
  error: null,
  dash1: [],
  dash2: [],
  dash3: [],
  dash4: [],
  dash5: [],
  dash6: [],

  chart1: [],
  chart2: [],
  chart3: [],
  chart4: []
};

const dashboards = createSlice({
  name: 'dashboards',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    // GET dash1
    getDashboard1(state, action) {
      state.dash1 = action.payload;
    },

    // GET dash2
    getDashboard2(state, action) {
      state.dash2 = action.payload;
    },

    // GET dash3
    getDashboard3(state, action) {
      state.dash3 = action.payload;
    },

    // GET dash4
    getDashboard4(state, action) {
      state.dash4 = action.payload;
    },

    // GET dash5
    getDashboard5(state, action) {
      state.dash5 = action.payload;
    },

    // GET dash6
    getDashboard6(state, action) {
      state.dash6 = action.payload;
    },

    getChart1(state, action) {
      state.chart1 = action.payload;
    },

    getChart2(state, action) {
      state.chart2 = action.payload;
    },

    getChart3(state, action) {
      state.chart3 = action.payload;
    },

    getChart4(state, action) {
      state.chart4 = action.payload;
    }
  }
});

// Reducer
export default dashboards.reducer;

// ----------------------------------------------------------------------

function toSerializableError(error: any) {
  return {
    message: error?.message ?? String(error) ?? 'Unknown error',
    status: error?.status ?? error?.response?.status ?? null,
    data: error?.data ?? error?.response?.data ?? null
  };
}

export function getFirstDashboard(id: string | undefined) {
  return async () => {
    try {
      const response = id ? await axios.get(`/api/asset/${id}/dash1`) : await axios.get(`/api/assets/dash1`);
      dispatch(dashboards.actions.getDashboard1(response.data));
    } catch (error) {
      dispatch(dashboards.actions.hasError(toSerializableError(error)));
    }
  };
}

export function getSecondDashboard(id: string | undefined) {
  return async () => {
    try {
      const response = id ? await axios.get(`/api/asset/${id}/dash2`) : await axios.get(`/api/assets/dash2`);
      dispatch(dashboards.actions.getDashboard2(response.data));
    } catch (error) {
      dispatch(dashboards.actions.hasError(toSerializableError(error)));
    }
  };
}

export function getThirdDashboard(id: string | undefined) {
  return async () => {
    try {
      const response = id ? await axios.get(`/api/asset/${id}/dash3`) : await axios.get(`/api/assets/dash3`);
      dispatch(dashboards.actions.getDashboard3(response.data));
    } catch (error) {
      dispatch(dashboards.actions.hasError(toSerializableError(error)));
    }
  };
}

export function getFourthDashboard(id: string | undefined) {
  return async () => {
    try {
      const response = id ? await axios.get(`/api/asset/${id}/dash4`) : await axios.get(`/api/assets/dash4`);
      dispatch(dashboards.actions.getDashboard4(response.data));
    } catch (error) {
      dispatch(dashboards.actions.hasError(toSerializableError(error)));
    }
  };
}

export function getFifthDashboard(id: string | undefined) {
  return async () => {
    try {
      const response = id ? await axios.get(`/api/asset/${id}/dash5`) : await axios.get(`/api/assets/dash5`);
      dispatch(dashboards.actions.getDashboard5(response.data));
    } catch (error) {
      dispatch(dashboards.actions.hasError(toSerializableError(error)));
    }
  };
}

export function getSixthDashboard(id: string | undefined) {
  return async () => {
    try {
      const response = id ? await axios.get(`/api/asset/${id}/dash6`) : await axios.get(`/api/assets/dash6`);
      dispatch(dashboards.actions.getDashboard6(response.data));
    } catch (error) {
      dispatch(dashboards.actions.hasError(toSerializableError(error)));
    }
  };
}

export function getFirstChart(id: string | undefined) {
  return async () => {
    try {
      const response = id ? await axios.get(`/api/asset/${id}/chart1`) : await axios.get(`/api/assets/chart1`);
      dispatch(dashboards.actions.getChart1(response.data));
    } catch (error) {
      dispatch(dashboards.actions.hasError(toSerializableError(error)));
    }
  };
}

export function getSecondChart(id: string | undefined) {
  return async () => {
    try {
      const response = id ? await axios.get(`/api/asset/${id}/chart12`) : await axios.get(`/api/assets/chart2`);
      dispatch(dashboards.actions.getChart2(response.data));
    } catch (error) {
      dispatch(dashboards.actions.hasError(toSerializableError(error)));
    }
  };
}

export function getThirdChart(id: string | undefined) {
  return async () => {
    try {
      const response = id ? await axios.get(`/api/asset/${id}/chart3`) : await axios.get(`/api/assets/chart3`);
      dispatch(dashboards.actions.getChart3(response.data));
    } catch (error) {
      dispatch(dashboards.actions.hasError(toSerializableError(error)));
    }
  };
}

export function getFourthChart(id: string | undefined) {
  return async () => {
    try {
      const response = id ? await axios.get(`/api/asset/${id}/chart4`) : await axios.get(`/api/assets/chart4`);
      dispatch(dashboards.actions.getChart4(response.data));
    } catch (error) {
      dispatch(dashboards.actions.hasError(error));
    }
  };
}
